<!-- Videollamada activa: ocupa toda la pantalla (el propio componente es un overlay) -->
@if (joined && room) {
  <app-jitsi-room
    [roomName]="room.roomName"
    [displayName]="guestName || 'Invitado'"
    [title]="room.title"
    [datetimeStart]="room.datetimeStart"
    [durationMinutes]="room.durationMinutes"
    (close)="onClose()">
  </app-jitsi-room>
} @else {
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900 py-8 px-4">
    <div class="max-w-xl mx-auto">
      @if (loading) {
        <div class="py-20 text-center text-gray-500 dark:text-gray-400">Cargando...</div>
      } @else if (notFound || error) {
        <div class="rounded-lg bg-white dark:bg-gray-800 shadow p-8 text-center space-y-3">
          <div class="inline-flex items-center justify-center w-16 h-16 rounded-full bg-error-100 text-error-600">
            <svg class="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </div>
          <p class="text-lg font-medium text-gray-900 dark:text-white">{{ error || 'Sala no encontrada.' }}</p>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            Verifica el enlace o contacta al organizador de la reunión.
          </p>
        </div>
      } @else if (room) {
        <div class="rounded-lg bg-white dark:bg-gray-800 shadow overflow-hidden">
          <div class="p-6 border-b border-gray-200 dark:border-gray-700">
            <div class="inline-flex items-center gap-2 text-brand-600 dark:text-brand-400 mb-3">
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
              </svg>
              <span class="text-sm font-medium">Videollamada</span>
            </div>
            <h1 class="text-2xl font-bold text-gray-900 dark:text-white">{{ room.title }}</h1>
            @if (formatFecha()) {
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-2">{{ formatFecha() }}</p>
            }
            @if (room.organizerName) {
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Organiza: {{ room.organizerName }}</p>
            }
          </div>

          <div class="p-6 space-y-4">
            <div>
              <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
                Tu nombre (opcional)
              </label>
              <input
                type="text"
                [(ngModel)]="guestName"
                placeholder="¿Cómo te ven los demás?"
                class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800"
              />
            </div>

            <button
              type="button"
              (click)="join()"
              class="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-brand-500 px-4 py-3 text-sm font-medium text-white transition-colors hover:bg-brand-600">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
              </svg>
              Entrar a la videollamada
            </button>

            <p class="text-xs text-center text-gray-400 dark:text-gray-500">
              Se abrirá la sala de video en esta misma página.
            </p>
          </div>
        </div>
      }
    </div>
  </div>
}
